import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["label", "icon"]
  static values = { 
    text: String,
    copiedText: { type: String, default: "Copied!" },
    duration: { type: Number, default: 1500 }
  }
  
  async copy(event) {
    event.preventDefault()
    
    try {
      await navigator.clipboard.writeText(this.textValue)
      this.showSuccess()
    } catch (err) {
      console.error("Failed to copy:", err)
    }
  }
  
  showSuccess() {
    const original = this.labelTarget.textContent
    this.labelTarget.textContent = this.copiedTextValue
    
    if (this.hasIconTarget) {
      this.iconTarget.classList.add("text-emerald-400")
    }
    
    setTimeout(() => {
      this.labelTarget.textContent = original
      if (this.hasIconTarget) {
        this.iconTarget.classList.remove("text-emerald-400")
      }
    }, this.durationValue)
  }
}
